(function () {
  const PRODUCT_SELECTOR = ".globo_color_swatch_bundle_quantity_break";

  const COLOR_IMAGES = {
    ZWART: "//zone2sportswear.com/cdn/shop/files/belt_bf87dc95-1b8e-4e2c-b70e-d14cd451feb8.jpg?v=1763463436&width=150&height=150",
    WIT: "//zone2sportswear.com/cdn/shop/files/White_belt.png?v=1763463436&width=150&height=150",
    ROZE: "//zone2sportswear.com/cdn/shop/files/Pink_belt.png?v=1763463436&width=150&height=150"
  };

  function closeAllDropdowns(exceptDropdown) {
    document.querySelectorAll(".z2-color-dropdown.is-open").forEach(function (dropdown) {
      if (dropdown !== exceptDropdown) {
        dropdown.classList.remove("is-open");
      }
    });
  }

  function buildColorDropdown(select) {
    if (select.dataset.z2ColorDropdownReady === "1") return;

    const dropdown = document.createElement("div");
    dropdown.className = "z2-color-dropdown";

    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "z2-color-dropdown__trigger";

    const optionList = document.createElement("div");
    optionList.className = "z2-color-dropdown__options";

    function renderTrigger() {
      const value = select.value;
      const image = COLOR_IMAGES[value] || "";

    trigger.innerHTML = `
    <span class="z2-color-dropdown__selected">
        <img class="z2-color-dropdown__image" src="${image}" alt="${value}">
        <span>${value}</span>
    </span>
    `;
    }

    Array.from(select.options).forEach(function (option) {
      const value = option.value;
      const image = COLOR_IMAGES[value] || "";

      const optionButton = document.createElement("button");
      optionButton.type = "button";
      optionButton.className = "z2-color-dropdown__option";
      optionButton.dataset.value = value;

      optionButton.innerHTML = `
        <img class="z2-color-dropdown__image" src="${image}" alt="${value}">
        <span>${value}</span>
      `;

      optionButton.addEventListener("click", function () {
        select.value = value;

        select.dispatchEvent(new Event("input", { bubbles: true }));
        select.dispatchEvent(new Event("change", { bubbles: true }));

        renderTrigger();
        dropdown.classList.remove("is-open");
      });

      optionList.appendChild(optionButton);
    });

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = dropdown.classList.contains("is-open");

      closeAllDropdowns(dropdown);

      if (!isOpen) {
        dropdown.classList.add("is-open");
      }
    });

    dropdown.appendChild(trigger);
    dropdown.appendChild(optionList);

    select.insertAdjacentElement("afterend", dropdown);

    renderTrigger();

    select.dataset.z2ColorDropdownReady = "1";
  }

  function initColorDropdowns() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block
        .querySelectorAll('.gcw-quantity-break__offer-variant-select[data-name="Kleur"]')
        .forEach(buildColorDropdown);
    });
  }

  function addVariantNumberSwatches() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block.querySelectorAll(".gcw-quantity-break__offer-variant__content").forEach(function (variantContent) {
        const numberBox = variantContent.querySelector(".gcw-quantity-break__offer-variant-number");
        const colorSelect = variantContent.querySelector('.gcw-quantity-break__offer-variant-select[data-name="Kleur"]');

        if (!numberBox || !colorSelect) return;

        let image = numberBox.querySelector(".z2-variant-number-swatch");

        if (!image) {
          image = document.createElement("img");
          image.className = "z2-variant-number-swatch";
          numberBox.appendChild(image);
        }

        function updateImage() {
          const color = colorSelect.value;
          image.src = COLOR_IMAGES[color] || "";
          image.alt = color;
        }

        updateImage();

        if (!colorSelect.dataset.z2SwatchBound) {
          colorSelect.addEventListener("change", updateImage);
          colorSelect.dataset.z2SwatchBound = "1";
        }
      });
    });
  }

  function updateFreeGiftTitles() {
  document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
    block.querySelectorAll(".free-gift--title").forEach(function (title) {
      const originalTitle = title.textContent.trim();

      if (!originalTitle) return;
      if (originalTitle.toUpperCase().startsWith("+ GRATIS")) return;

      title.textContent = "+ GRATIS " + originalTitle;
    });
  });
}



    function addExtraLabelsToTwoBelts() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
        block.querySelectorAll(".gcw-quantity-break__offer").forEach(function (offer) {
        const title = offer.querySelector(".gcw-quantity-break__offer-title");
        const firstLine = offer.querySelector(".gcw-quantity-break__offer-first-line");

        if (!title || !firstLine) return;

        const titleText = title.textContent.trim().toUpperCase();

        if (titleText !== "2 BELTS") return;

        const labelsToAdd = ["GRATIS 300ML SOFT FLASK"];

        labelsToAdd.forEach(function (labelText) {
            if (firstLine.querySelector('[data-z2-extra-label="' + labelText + '"]')) return;

            const label = document.createElement("span");
            label.className = "gcw-quantity-break__offer-label";
            label.dataset.z2ExtraLabel = labelText;
            label.textContent = labelText;

            firstLine.appendChild(label);
        });
        });
    });
    }


    function wrapTwoBeltsLabels() {
        document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
            block.querySelectorAll(".gcw-quantity-break__offer").forEach(function (offer) {
            const title = offer.querySelector(".gcw-quantity-break__offer-title");
            const firstLine = offer.querySelector(".gcw-quantity-break__offer-first-line");

            if (!title || !firstLine) return;

            const titleText = title.textContent.trim().toUpperCase();

            if (titleText !== "2 BELTS") return;

            if (firstLine.querySelector(".z2-offer-labels-wrap")) return;

            const labels = Array.from(firstLine.querySelectorAll(".gcw-quantity-break__offer-label"));

            if (!labels.length) return;

            const labelWrap = document.createElement("span");
            labelWrap.className = "z2-offer-labels-wrap";

            labels.forEach(function (label) {
                labelWrap.appendChild(label);
            });

            title.insertAdjacentElement("afterend", labelWrap);
            });
        });
        }


        


function hideNullFreeGiftText() {
  document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
    block.querySelectorAll(".free-gift--text").forEach(function (textEl) {
      const text = textEl.textContent.trim().toLowerCase();

      if (text === "null") {
        textEl.style.display = "none";
      }
    });
  });
}

function updateHardcodedBundlePricing() {
  const SINGLE_BELT_PRICE = "24,95";
  const DEAL_PRICE_PER_BELT = "18,72";

  document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
    const singleOffer = block.querySelector('.gcw-quantity-break__offer[data-offer-index="0"]');
    const dealOffer = block.querySelector('.gcw-quantity-break__offer[data-offer-index="1"]');

    if (singleOffer) {
      const price = singleOffer.querySelector(".gcw-quantity-break__offer-price");
      const comparePrice = singleOffer.querySelector(".gcw-quantity-break__offer-compare-price");

      setTextIfChanged(price, SINGLE_BELT_PRICE);

      if (comparePrice) {
        setTextIfChanged(comparePrice, "");
        comparePrice.style.display = "none";
      }
    }

    if (dealOffer) {
      const price = dealOffer.querySelector(".gcw-quantity-break__offer-price");
      const comparePrice = dealOffer.querySelector(".gcw-quantity-break__offer-compare-price");

      setTextIfChanged(price, DEAL_PRICE_PER_BELT);

      if (comparePrice) {
        setTextIfChanged(comparePrice, SINGLE_BELT_PRICE);
        comparePrice.style.display = "";
      }
    }
  });
}

function setTextIfChanged(element, value) {
  if (!element) return;

  if (element.textContent.trim() !== value) {
    element.textContent = value;
  }
}


  function initBeltBundle() {
    initColorDropdowns();
    addVariantNumberSwatches();
    updateFreeGiftTitles();
      hideNullFreeGiftText();

    addExtraLabelsToTwoBelts();
    wrapTwoBeltsLabels();
    updateHardcodedBundlePricing();
    }

  document.addEventListener("click", function () {
    closeAllDropdowns();
  });

  initBeltBundle();

  const observer = new MutationObserver(initBeltBundle);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();




(function () {
  function findSizeGuideToggle() {
    const nodes = Array.from(document.querySelectorAll('[class*="__ss_size_guide_2_"]'));

    for (const el of nodes) {
      if (typeof el.className === "string" && el.className.includes("size-toggle-")) {
        return el;
      }
    }

    return null;
  }

  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest("[data-z2-open-size-guide]");
    if (!openBtn) return;

    e.preventDefault();

    const toggle = findSizeGuideToggle();

    if (toggle) {
      toggle.click();
    }
  });
})();